import { useMemo } from 'react';

import { AuthService } from 'shared/lib/keycloak';
import { Org, useGetOnboardingUserInfoQuery } from 'shared/api/onboarding';
import { useAppSelector } from 'shared/lib/redux';

interface State {
  activeOrgs: Org[];
  schools: Org[];
  districts: Org[];
}

export const useUserOrgs = () => {
  const userBk = AuthService.getUserBk();

  const hasError = useAppSelector(
    (state) =>
      state.onboarding.queries[`getOnboardingUserInfo("${userBk}")`]?.status ===
      'rejected',
  );

  const { data: onboardingUserInfo, isLoading } = useGetOnboardingUserInfoQuery(
    userBk,
    {
      skip: !userBk || hasError,
    },
  );

  const state: State = useMemo(() => {
    if (!onboardingUserInfo)
      return {
        activeOrgs: [],
        schools: [],
        districts: [],
      };

    const userOrgs = onboardingUserInfo.orgs;

    // search district org among all user orgs as it doesn't have status
    const districts = userOrgs.filter((org) => org.orgType === 'district');

    const activeOrgs = userOrgs.filter((org) => org.orgStatus === 'active');

    // School should be active
    const schools = activeOrgs.filter((org) => org.orgType === 'school');

    return {
      activeOrgs,
      schools,
      districts,
    };
  }, [onboardingUserInfo]);

  return { ...state, isLoading };
};
